let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cxMII")).then(() => parcelRequire('erbJ6'));